export default {
  path: '/contracts',
  name: 'contracts',
  component: () => import('../components/contract/Layout'),
  redirect: { name: 'ContractList' },
  meta: {
    breadcrumb: 'contract.contracts',
  },
  children: [
    {
      name: 'ContractList',
      path: '',
      component: () => import('../views/contract/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ContractCreate',
      path: 'new',
      component: () => import('../views/contract/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ContractUpdate',
      path: ':id/edit',
      component: () => import('../views/contract/Update'),
      meta: {
        breadcrumb: 'contract.contract',
      },
    },
    {
      name: 'ContractShow',
      path: ':id',
      component: () => import('../views/contract/Show'),
      meta: {
        breadcrumb: 'contract.contract',
      },
    }
  ]
};
